module.exports = __webpack_public_path__ + "static/keep-team-on-the-same-page-7b4e0c969500461f1becca2c5a90b1ed.png";